export const mobileRestrictionText = {
  title: 'Optimizing Your Experience',
  info: "To ensure a smooth and enjoyable app experience, we advise using a tablet in landscape mode, notebook, or PC. The constraints of a mobile device's screen size may impact the app's functionality. Therefore, we recommend opting for a larger device for optimal use.",
};
